var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorPunteado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 566,
    height: 29,
    viewBox: "0 0 566 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5C142.781 5 440.719 5 561 5M5 23.5C215.297 23.5 333.203 23.5 543.5 23.5",
    stroke: "#50DEDA",
    strokeWidth: 10,
    strokeMiterlimit: 3.8637,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.1 20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorPunteado);
export default __webpack_public_path__ + "static/media/vector-punteado.9f507035adcf38cc1f6d5470ac21c884.svg";
export { ForwardRef as ReactComponent };